import { Container, LoginWrapper, Logo, LoginCard } from '../index'
import { Divider, Title, Button, Line, Text } from './styled'

interface EmailSentScreenProps {
  onGoBack: () => void
}

export const EmailSentScreen = ({ onGoBack }: EmailSentScreenProps) => {
  return (
    <Container height="100vh">
      <LoginWrapper>
        <Logo />
        <LoginCard>
          <Divider />
          <Title>Check Your Email</Title>
          <Text>
            A secure link has been sent to your email address. Click the link in
            your email to log in.
          </Text>
          <Line />
          <Button onClick={onGoBack}>Go Back</Button>
        </LoginCard>
      </LoginWrapper>
    </Container>
  )
}
